<template>
  <div class="form-view" :class="platformClass">
    <UserInfoForm />
  </div>
</template>

<script setup>
import { computed } from "vue";
import UserInfoForm from "@/components/common/UserInfoForm.vue";
import { useAppStore } from "@/stores/app.js";

const appStore = useAppStore();

// 计算属性
const platformClass = computed(() => appStore.platformClass);
</script>

<style lang="scss" scoped>
.form-view {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; // iOS 平滑滚动
}



.is-desktop {
  // 桌面端特殊样式
  max-width: 480px;
  margin: 0 auto;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}
</style>
